import React from "react";
import { Routes, Route } from "react-router-dom";
import { UserContextProvider } from "./components/UserContext";
import Post from "./components/Post";
import Login from "./components/Login";
import Register from "./components/Register";
import CreatePost from "./components/CreatePost";
import MainContent from "./components/MainContent";
import EditPost from "./components/EditPost";
import NotFound from "./components/NotFound";
import Profile from "./components/Profile";
import MyBlog from "./components/MyBlog";
import AdminPanel from "./components/AdminPanel";
import { useTheme } from "./components/ThemeContext";
import LampPull from "./components/LampPull";
import Navbar from "./components/Navbar";


function Layout({ children }) {
  const { theme, toggle } = useTheme()
  return (
    <div className="min-h-screen">
      {/* Global lamp feature behind everything, but interactive */}
      <LampPull theme={theme} onToggle={toggle} />

      {/* Content container with smooth theme transition */}
      <div
        className="relative z-10 min-h-screen transition-colors duration-700"
        style={{
          color: theme === 'dark' ? 'rgba(255,255,255,0.92)' : '#0f172a',
        }}
      >
        {children}
      </div>
    </div>
  )
}


function App() {
  return (
    <UserContextProvider>
      <Layout>
        <Navbar />
        <main className="flex-1 max-w-4xl mx-auto w-full pt-20 py-10 px-4">
          <Routes>
            <Route index element={<Post />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/create" element={<CreatePost />} />
            <Route path="/post/:id" element={<MainContent />} />
            <Route path="/edit/:id" element={<EditPost />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/my-blog" element={<MyBlog />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <footer className="bg-white border-t py-6 text-center text-gray-500 text-sm">
          &copy; {new Date().getFullYear()} BlogWeb. All rights reserved.
        </footer>
      </Layout>
    </UserContextProvider>
  );
}

export default App;